import {setSmoother,gsap, ScrollSmoother, ScrollTrigger, SplitText, forceScrollSmootherUpdate, smoother, Flip, scrollPosition} from "./gsap";
import {documentReady, observeElementResize, scrollToEl } from "./utils";
import Dom from '../utility/dom';

// const body = document.querySelector('body');
const body = Dom.body;
let scrollTop = smoother ? smoother.scrollTop() : 0;
window.addEventListener('resize',()=>{
    scrollTop = smoother ? smoother.scrollTop() : 0;
});

const InitializeSmoothing = () => {
    gsap.registerPlugin(ScrollTrigger);

    if(!!body.querySelector('.scroll-smoother-wrapper')){
        // Register GSAP Plugins (comma separated) including:
        // ScrollTrigger, ScrollSmoother, SplitText, and Flip.
        gsap.registerPlugin(ScrollSmoother);
    
        ScrollTrigger.config({ 
            ignoreMobileResize: true,
            refreshPriority: 9,
        })
        
        documentReady(()=>{
            observeElementResize(document.querySelector('#page'), ()=>{
                if(body.classList.contains('prevent-smoother-update')) return;

                forceScrollSmootherUpdate(); 
            });

            // If the page lands on a url with an anchor, update smooth scroll to
            // that position
            const hash = window.location.hash;
            const target = hash ? document.querySelector(hash) : null;
            if(!!target){
                setTimeout(()=> {
                    if(smoother){
                        ScrollSmoother.get().scrollTo(target, true, "top 50px");
                    }
                    else {
                        scrollToEl(target);
                    }
                }, 1000);
            }

        })
        
        //no scrollsmoother on mobile - too glitchy on ios
        if (!ScrollTrigger.isTouch) {
            body.classList.add('smoothscroll');

            setSmoother(ScrollSmoother.create({
                wrapper: ".scroll-smoother-wrapper",
                content: ".site",
                smooth: 0.4,
                ease:"power4.out",
                effects: true,
                ignoreMobileResize: true,
                normalizeScroll: true,
                smoothTouch: 0.1,
            }));

            // This ensure's overflow:scroll works for nested content.
            ScrollTrigger.normalizeScroll({
                allowNestedScroll: true
            });
        }
    }
}

export const watchAnimations = () => {
    const els = document.querySelectorAll('[class*="td_animation"]');
    
    if(els){
        els.forEach(el => {
            setAnimationScrollTrigger(el);
        });
    }
}


export const setAnimationScrollTrigger = (el) =>{
    if(!el.classList.contains('animated') && el.animationSet == undefined){
        el.animationSet = true;
        const anim = ScrollTrigger.create({
            trigger: el,
            // markers: true,
            start: () => {
                let offset = window.outerWidth < 991 ? 20 : 130;
                
                // If the element is above the fold on load, set the offset to 0
                const elTop = el.getBoundingClientRect().top;
                if(elTop < window.innerHeight){
                    offset = 0;
                }

                return `top bottom-=${offset}`;
            }, 
            end: "bottom top",
            onEnter: () => {
                // For elements in a grid, check if they should be staggered:
                const gridParent = el.closest('.grid-container_wrapper, .splide__list, .post_feed__list');

                // Check if the element style attribute has a --stagger-index value already set
                const style = el.getAttribute('style');
                const hasStaggerIndex = style && style.indexOf('--stagger-index') > -1;

                if(!!gridParent && !hasStaggerIndex){
                    const children = Array.from(gridParent.children);
                    
                    // check if there are other children inline with the current element
                    const elTop = el.getBoundingClientRect().top;
                    let staggerIndex = 0;
                    for(let i=0; i<children.length; i++){
                        const child = children[i];
                        if(child === el) break;

                        if(el.classList.contains('splide__slide')
                        || Math.abs(child.getBoundingClientRect().top - elTop) < 5){
                            staggerIndex++;
                        }
                    }
                    el.style.setProperty('--stagger-index', staggerIndex);
                }

                // Add animation class
                el.classList.add('animated');
                
                setTimeout(() => {
                    anim.kill(false);
                }, 2000);
            }
        });
    }
}

const InitializeSmoothAnchorLinks = () => {

    document.querySelectorAll("a[href^='#']").forEach((a) => {

        const linkHandler = (e) => {
            e.preventDefault();
            if(a.hash){
                if('preventDefault' in a.dataset) return;
                
                const target = document.querySelector(a.hash);
                if(!!target && !Dom.prefersReducedMotion){
                    const targetPos = smoother ? smoother.offset(target, "top top") : target.getBoundingClientRect().top;
    
                    if(smoother){
                        smoother.scrollTo(target, true, "top 50px");
                    }
                    else {
                        scrollToEl(target);
                    }
    
                    // Hide the header for better landing.
                    const header = document.querySelector('#masthead');
                    header.classList.add('hide-while-scrolling');
                    setTimeout(()=>{
                        header.classList.add('hide-header');
                        header.classList.remove('hide-while-scrolling');
                    }, 1100);
                }
            }
        };

        a.addEventListener("click", linkHandler);
    });
}


const IntializeHeaderState = () => {
    const header = document.querySelector('#masthead');

    ScrollTrigger.create({
        trigger: body,
        start: ()=>{
            const top = 'top+=' + scrollTop;
            return top + " top"
        },
        end: () => {
            const height = body.getBoundingClientRect().height;
            const bottom = 'bottom+=' + scrollTop + height;
            return bottom + " bottom";
        },
        onUpdate: self => {
            if(body.classList.contains('prevent-smoother-update')) return;

            const hiddenClass = 'hide-header';
            const scrolledClass = 'header-scrolled';
            
            // Always show header above 400px scroll position
            if(scrollPosition() < 400) {
                if(header.classList.contains(hiddenClass)){
                    header.classList.remove(hiddenClass);
                }
                if(body.classList.contains(scrolledClass)){
                    body.classList.remove(scrolledClass);
                }
            }
            else if(scrollPosition() >= 400) {
                if(!body.classList.contains(scrolledClass)){
                    body.classList.add(scrolledClass)
                }

                if(self.direction == -1 
                && header.classList.contains(hiddenClass)
                && !body.classList.contains('preventHeaderReveal')){
                    header.classList.remove(hiddenClass);
                }
                else if(self.direction == 1 
                && !header.classList.contains(hiddenClass)
                && !body.classList.contains('preventHeaderHide')){
                    header.classList.add(hiddenClass);
                }
            }
        }
    });
}

export const prepareElsForAnimation = () => {
    const startPrep = (els, startTransform = 'translateY(20px)') => {
        if(!els) return;
        let staggerIndex = 0;

        els.forEach(el => {
            if(!el.classList.contains('td_animation')){
                el.style.opacity = 0;
                el.style.transform = startTransform;
                el.style.setProperty('transition-delay', '0s !important');
                el.style.setProperty('--stagger-index', staggerIndex);
                staggerIndex++;
            }
        });
    }

    const finishPrep = (els) => {
        if(!els) return;

        setTimeout(() => {
            els.forEach(el => {
                if(!el.classList.contains('td_animation')){
                    el.style.opacity = '';
                    el.style.transform = '';
                    el.classList.add('td_animation');
                    el.classList.add('fade-in-up');
                    el.style.removeProperty('transition-delay');
                }
            });
        }, 100);
    }

    // Add animation class to h1 elements
    const headings = document.querySelectorAll('h1, .h1');
    if(headings){
        headings.forEach(heading => {
            if(!heading.classList.contains('td_animation')){
                let els = [heading];

                // When an h1 is included in a group with a small amount
                // of other items, we'll animate them to
                const parent = heading.parentElement;
                if(!!parent){
                    const siblings = Array.from(parent.children).filter(child => child !== heading);
                    if(siblings.length > 0 && siblings.length < 5){
                        siblings.forEach(sibling => {
                            els.push(sibling);
                        });
                    }
                }

                startPrep(els);
                finishPrep(els);
            }
        });
    }

    const formEls = document.querySelectorAll('.gform_fields');
    if(formEls){
        formEls.forEach(formEl => {
            formEl.classList.add('fade-in-children-left');
            formEl.classList.add('setting_animation');
        });
        setTimeout(() => {
            formEls.forEach(formEl => {
                formEl.classList.add('td_animation');
                formEl.classList.remove('setting_animation');
            });
        }, 100);
    }

    setTimeout(() => {
        watchAnimations();
    }, 200);
}
 

const InitializeGSAPOnPageLoad = () => {

    InitializeSmoothing();
    InitializeSmoothAnchorLinks();
    IntializeHeaderState();
    prepareElsForAnimation();

    forceScrollSmootherUpdate();


    window.addEventListener("load", (e) => {
        // Anchor links don't smooth scroll until the page has 
        // been scrolled so we'll move the page 1px on load.
        const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        scroll({
            top: currentScroll+1,
            behavior: "smooth",
        });
        
        if (window.location.hash && smoother) {
            ScrollSmoother.get().scrollTo(window.location.hash, true);
        }
    });

}

export { gsap, InitializeGSAPOnPageLoad }
